<template>
    <modal :title="setModel!=null?'Update Customer Note':'Add Customer Note'" @close="$emit('close')">
        <template #content>
            <Form method="dialog" v-slot="{ errors }" class="floating-labels p-1rem align-items-start" ref="form">
                <formGroup :title="'Note'" as="textarea" rows="10" v-model="model.Note" :errors="errors" :rules="{required:true}"></formGroup>
            </Form>
        </template>
        <template #foot>
            <Btn class="btn-success btn-md" @click="save" :process="process">{{setModel!=null?'Update Customer Note':'Add Customer Note'}}</Btn>
        </template>
    </modal>
</template>

<script>
    export default {
        props:{
            setModel:Object,
            CustomerId:Number
        },
        emits:["add","update","close"],
        data(){
            return{
                model:{
                    Id:null,
                    CustomerId:this.CustomerId,
                    Note:null  
                },
                process:false
            }
        },
        created(){
            if(this.setModel!=null){
                this.model.Id=this.setModel.Id;
                this.model.Note=this.setModel.Note;
            }
        },
        methods:{
            save(){
                this.$refs.form.validate().then(valid =>{
                    if(valid.valid){
                        this.process=true;
                        this.$appAxiosAdmin.put(`CustomerNotes`,this.model).then(response => {
                            this.process=false;
                            this.$swal({
                                icon:"success",
                                title:"Success",
                                text:this.setModel!=undefined?"The customer note has been successfully updated.":"The customer note has been successfully added.",
                                timer: 2000,
                                confirmButtonText:"Okey"
                            });
                            if(this.setModel!=null){
                                this.$emit("update",response.data);
                            }else{
                                this.$emit("add",response.data);
                            }
                            this.$emit("close");
                        }).catch(err=>{
                            this.process=false;
                            this.$isError(err);
                        });
                    }
                });
            }
        }
    }
</script>

<style>

</style>